<template>
<div v-closable="{ exclude: ['contextLabelWrapper'], isClosable: true, handler: 'closeEditable'}">
  <div :ref="'contextLabelWrapper'" @click="handleEditing" class="context--label" :class="{ 'editable': isEditable, 'editing': flagEdit }">
    <div v-if="isLoading" class="context--label__icon placeholderLoader">
      <i :class="icon"></i>
    </div>
    <div v-else-if="hasIconMargin" :class="{'icon--hidden': !isIconVisible}" class="context--label__icon">
      <v-tooltip left :disabled="iconTooltip === null">
        <template v-slot:activator="{ on }">
          <i v-on="on" :class="icon"></i>
        </template>
        <span>{{ iconTooltip }}</span>
      </v-tooltip>
    </div>
    <div class="context--label__items">
      <template v-for="(label, index) in localLabels">
          <div :key="index" v-if="isLoading" class="placeholderLoader">
            <span class="label--text">
              {{'loading'}}
            </span>
          </div>
          <div v-else :key="index" :style="{backgroundColor: (label.color ? label.color : '#767676')}">
            <span class="label--text">
              {{(label.noTranslate ? label.name : $t(label.name))}}
            </span>
            <span v-if="label.value" class="label--value">
              {{label.value}}
            </span>
            <span v-if="flagEdit" @click="removeLabel(index)" class="label--delete">
              <i class="fa fa-times"></i>
            </span>
          </div>
      </template>
      <div class="context--label--edit__wrapper" v-show="flagEdit" style="position: relative;">
          <input class="context--label--edit__input" type="text" @keyup.enter="addNewLabel"
v-model="newLabel" @input="searchForLabels" :ref="labelEditableID"/>
      </div>
    </div>
    <div :ref="'contextLabelAutocomplete'" v-show="flagEdit" class=context--label--edit__autocomplete>
      <div>
        <template v-for="(label, index) in availableLabels">
            <a @click="addExistingLabel(label)" :key="index">{{label}}</a>
        </template>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { uuid } from 'vue-uuid'
import { algoliaService } from '@/_services'
export default {
  name: 'ContextLabel',
  props: {
    icon: { type: String, default: 'fas fa-tag' },
    isIconVisible: { type: Boolean, default: true },
    isLoading: { type: Boolean, default: false },
    labels: { type: Array, default: () => [] },
    isEditable: { type: Boolean, default: false },
    hasIconMargin: { type: Boolean, default: true },
    algoliaIndex: { type: String, default: 'prod_shipments' },
    iconTooltip: { type: String, default: null }
  },
  data () {
    return {
      flagEdit: false,
      newLabel: '',
      localLabels: null,
      labelEditableID: null,
      defaultLabels: [],
      availableLabels: []
    }
  },
  mounted () {
    this.localLabels = this.labels
    this.labelEditableID = uuid.v4()
    if (this.isEditable) {
      this.searchForLabels('initial')
    }
  },
  methods: {
    handleEditing (evt) {
      if (this.isEditable) {
        if (!evt.target.classList.contains('fa-times')) {
          this.$nextTick(() => {
            if (this.isEditable) {
              setTimeout(() => {
                this.$refs[this.labelEditableID].focus()
              }, 20)
            }
          })
          if (!this.$refs['contextLabelAutocomplete'].contains(evt.target)) {
            this.flagEdit = !this.flagEdit
          }
        }
      }
    },
    closeEditable () {
      // this.$emit('changeLabels', this.localLabels)
      this.newLabel = ''
      this.flagEdit = false
    },
    removeLabel (index) {
      this.flagEdit = true
      this.localLabels.splice(index, 1)
      this.$nextTick(() => {
        if (this.isEditable) {
          setTimeout(() => {
            this.$refs[this.labelEditableID].focus()
          }, 20)
        }
      })
    },
    addNewLabel () {
      if (this.newLabel.length > 0) {
        const arrayLabels = this.newLabel.split(',')
        arrayLabels.forEach((label) => {
          const index = this.localLabels.findIndex(({ name }) => {
            return label === name
          })
          if (index < 0) {
            this.localLabels.push({ name: label, color: this.localLabels.length % 2 ? '#FFB900' : '#ef476f', noTranslate: true })
          }
        })
        this.newLabel = ''
        this.availableLabels = this.defaultLabels
        this.$nextTick(() => {
          if (this.isEditable) {
            setTimeout(() => {
              this.$refs[this.labelEditableID].focus()
            }, 20)
          }
        })
      }
    },
    addExistingLabel (label) {
      const arrayLabels = label.split(',')
      arrayLabels.forEach((label) => {
        this.localLabels.push({ name: label, color: this.localLabels.length % 2 ? '#FFB900' : '#ef476f', noTranslate: true })
      })
      this.availableLabels = this.defaultLabels.filter((label) => this.localLabels.findIndex(({ name }) => {
        return label === name
      }) < 0)
      this.$nextTick(() => {
        if (this.isEditable) {
          setTimeout(() => {
            this.$refs[this.labelEditableID].focus()
          }, 20)
        }
      })
    },
    searchForLabels (flag = 'input') {
      if (this.newLabel.length > 2 || flag === 'initial') {
        algoliaService.getAllFacetsForAttribute(this.algoliaIndex, ['labels'], this.newLabel).then((response) => {
          this.availableLabels = response.filter((label) => this.localLabels.findIndex(({ name }) => {
            return label === name
          }) < 0)
          if (flag === 'initial') {
            this.defaultLabels = response.filter((label) => this.localLabels.findIndex(({ name }) => {
              return label === name
            }) < 0)
          }
        })
      } else {
        this.availableLabels = this.defaultLabels.filter((label) => this.localLabels.findIndex(({ name }) => {
          return label === name
        }) < 0)
      }
    }
  },
  watch: {
    labels: {
      deep: true,
      handler () {
        this.localLabels = this.labels
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
